import Rails from "@rails/ujs";
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["subject", "message"]

  connect() {
  }

  stripHtml(html) {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || '';
  }

  insert(event) {
    event.preventDefault();
    let templateId = event.target.dataset.id;
    let stripHtml = event.target.dataset.stripHtml === 'true';

    fetch(`/message_templates/${templateId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then((response) => response.json())
    .then((data) => {
      this.messageTarget.value = stripHtml ? this.stripHtml(data.message_body) : data.message_body;
      if (this.hasSubjectTarget) {
        this.subjectTarget.value = stripHtml ? this.stripHtml(data.subject) : data.subject;
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }


}
